export const FETCH_STATIC_CONTENT_TEMPLATES_REQUEST =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATES_REQUEST'
export const FETCH_STATIC_CONTENT_TEMPLATES_SUCCESS =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATES_SUCCESS'
export const FETCH_STATIC_CONTENT_TEMPLATES_FAILURE =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATES_FAILURE'

export const FETCH_STATIC_CONTENT_TEMPLATE_REQUEST =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATE_REQUEST'
export const FETCH_STATIC_CONTENT_TEMPLATE_SUCCESS =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATE_SUCCESS'
export const FETCH_STATIC_CONTENT_TEMPLATE_FAILURE =
  'staticContentTemplates/FETCH_STATIC_CONTENT_TEMPLATE_FAILURE'

export const DELETE_STATIC_CONTENT_TEMPLATE_REQUEST =
  'staticContentTemplates/DELETE_STATIC_CONTENT_TEMPLATE_REQUEST'
export const DELETE_STATIC_CONTENT_TEMPLATE_SUCCESS =
  'staticContentTemplates/DELETE_STATIC_CONTENT_TEMPLATE_SUCCESS'
export const DELETE_STATIC_CONTENT_TEMPLATE_FAILURE =
  'staticContentTemplates/DELETE_STATIC_CONTENT_TEMPLATE_FAILURE'

export const UPDATE_STATIC_CONTENT_TEMPLATE_REQUEST =
  'staticContentTemplates/UPDATE_STATIC_CONTENT_TEMPLATE_REQUEST'
export const UPDATE_STATIC_CONTENT_TEMPLATE_SUCCESS =
  'staticContentTemplates/UPDATE_STATIC_CONTENT_TEMPLATE_SUCCESS'
export const UPDATE_STATIC_CONTENT_TEMPLATE_FAILURE =
  'staticContentTemplates/UPDATE_STATIC_CONTENT_TEMPLATE_FAILURE'

export const UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_REQUEST =
  'staticContentTemplates/UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_REQUEST'
export const UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_SUCCESS =
  'staticContentTemplates/UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_SUCCESS'
export const UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_FAILURE =
  'staticContentTemplates/UPLOAD_STATIC_CONTENT_TEMPLATE_FILE_FAILURE'

export const UPDATE_FIELD = 'staticContentTemplates/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'staticContentTemplates/SET_DEFAULT_DATA'
